import { useContext } from 'react';

import { EventManagerContext } from './EventManagerContext.js';

export const useEvents = () => {
  const ctx = useContext(EventManagerContext);

  if (!ctx) {
    throw new Error('useEvents must be used within a EventManagerProvider');
  }

  return ctx;
};
